import CsnDashboard from './CsnDashboard'

export default CsnDashboard
